<template>  
  <div class="lead-generation">
    <h1 v-html="header.title" class="lead-generation__title" v-if="header.title" :style="titleStyle"></h1>
    <div class="lead-generation__banner" :style="`background:${header.colorBackground}`" v-if="!header.bannerDesktop"></div>
    <img :src="headerImage"  class="lead-generation__image" v-if="header.bannerDesktop || header.bannerMobile">
  </div>
</template>

<script>
export default {
  component: 'LeadGenerationBanner',
  props: {
    header: {
      type: Object,
      default: () => ({}),
      required: false
    }
  },
  computed: {
    titleStyle () {
      return `text-align:${this.header.alignText};font-size:${this.$mq === 'mobile'? this.header.fontSizeMobile:this.header.fontSizeDesktop}`
    },
    headerImage () {
      return  this.$mq === 'mobile'? this.header.bannerMobile:this.header.bannerDesktop;
    }
  }
}
</script>

<style scoped lang="scss">
.lead-generation {
  text-align: center;
  &__image{
    width: 60%;
    @include mobile-only {
      width: 100%;
    }
  }
  &__banner {
    height: 487px;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &__title{
    margin-top: 10px;
  }
}
</style>